import React from "react";
import { useTranslation } from "react-i18next";
import { CreationProps } from "@/pages/Home/index.d";
import "./index.scss";

interface WorkListProps {
  items: CreationProps[];
  buttonImage: string;
  onVote?: (item: CreationProps) => void;
}

const WorkList: React.FC<WorkListProps> = ({
  items = [],
  buttonImage,
  onVote,
}) => {
  const { t } = useTranslation();

  const WorkItem: React.FC<{
    url: string;
    name: string;
    voteCount: number;
    coverImage?: string;
    buttonImage: string;
    onVote?: () => void;
  }> = ({ url, name, voteCount, coverImage, buttonImage, onVote }) => {
    console.log({ coverImage });

    return (
      <div className='workItem'>
        <div
          className='cover'
          onClick={() => window.open(url, "_blank")}
          style={{
            // backgroundImage: coverImage ? `url(${coverImage})` : undefined,
            backgroundImage: `url(${coverImage})` || undefined,
          }}></div>
        <div className='title'>
          <div className='left'>
            {/* 没名字 也要占位 */}
            <div className='name'>{name || "\u00A0"}</div>
            <div className='voteCount'>
              {t("voteCount")}：{voteCount}
            </div>
          </div>
          <div className='btn'>
            <div className='vote' onClick={onVote}>
              <img src={buttonImage} alt='' />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='workList'>
      {items?.map((item) => (
        <WorkItem
          key={item.id}
          url={item.url}
          name={item.name}
          voteCount={item.vote_count}
          coverImage={item.cover}
          buttonImage={buttonImage}
          onVote={() => onVote?.(item)}
        />
      ))}
    </div>
  );
};

export default WorkList;
